import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { useCallback, useEffect, useRef, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddQNAModal from "../components/AddQNAModal";
import ReactQuill from "react-quill";

const FaqAccordian = (props) => {
  const { title, data, setData } = props;

  const prevProps = useRef();

  const [showQNAModal, setShowQNAModal] = useState(false);
  const [selectedQNA, selectQNA] = useState(null);
  const [faqs, setFaqs] = useState([]);

  useEffect(() => {
    setFaqs(data?.faqs);
  }, [data?.faqs]);

  useEffect(() => {
    if (JSON.stringify(faqs) !== prevProps?.current?.prevFaqs) {
      setData((preState) => ({ ...preState, faqs }));
    }

    return () => {
      prevProps.current = {
        prevFaqs: JSON.stringify(faqs),
      };
    };
  }, [faqs]);

  const handleQNAModal = useCallback((show = false, selectedObj) => {
    show = typeof show === "boolean" && show;
    setShowQNAModal(show);
    selectQNA(selectedObj);
  }, []);

  const handleQNAemove = useCallback((index) => {
    setFaqs((prevState) => prevState.filter((_, i) => i !== index));
  }, []);

  const handleQNA = useCallback((qnaObj) => {
    let { index, ...rest } = qnaObj;
    if (index !== undefined) {
      setFaqs((prevState) =>
        prevState.map((obj, i) => (i === index ? rest : obj))
      );
    } else {
      setFaqs((preState) => [...preState, qnaObj]);
    }
  }, []);

  const handleChange = useCallback(
    (name) => (e) => {
      let value = e?.target?.value ?? e?.target?.checked ?? e;

      setData((preState) => ({ ...preState, [name]: value }));
    },
    [setData]
  );

  return (
    <>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2a-content"
          id="panel2a-header"
        >
          <Typography fontWeight={"600"}>{title}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <div className="form_comp">
            <label htmlFor="title">Title</label>
            <ReactQuill
              placeholder="Enter title"
              value={data?.title}
              onChange={handleChange("title")}
              theme="snow"
              className="edit_container"
              bounds={`[data-text-editor="name"]`}
            />
          </div>
          <div className="form_comp">
            <label htmlFor="title">Description</label>
            <ReactQuill
              placeholder="Enter description"
              value={data?.description}
              onChange={handleChange("description")}
              theme="snow"
              className="edit_container"
              bounds={`[data-text-editor="name"]`}
            />
          </div>
          <div className="btn-container mt15">
            <Button
              variant="contained"
              className="bordered-button float-right"
              onClick={() => handleQNAModal(true)}
            >
              + Add QNA
            </Button>
          </div>

          <TableContainer component={Paper} sx={{ mt: 2 }}>
            <Table sx={{ minWidth: 650, px: 2 }} aria-label="simple table">
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{ fontWeight: 700 }}
                    align="left"
                    className="tablecell"
                  >
                    Question
                  </TableCell>
                  <TableCell
                    style={{ fontWeight: 700 }}
                    align="left"
                    className="tablecell"
                  >
                    Answer
                  </TableCell>

                  <TableCell
                    style={{ fontWeight: 700 }}
                    align="left"
                    className="tablecell"
                  >
                    Edit
                  </TableCell>
                  <TableCell
                    style={{ fontWeight: 700 }}
                    align="left"
                    className="tablecell"
                  >
                    Delete
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {faqs?.map((qObj, index) => {
                  return (
                    <TableRow
                      key={index}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                    >
                      <TableCell align="left" component="th" scope="row">
                        <Box className="origin_des">
                          <Box>
                            <Typography
                              style={{
                                maxWidth: 200,
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              }}
                              className="font600 fs_14"
                              dangerouslySetInnerHTML={{
                                __html: qObj?.question,
                              }}
                            />
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell align="left" component="th" scope="row">
                        <Box className="origin_des">
                          <Box
                            sx={{
                              ml: 3,
                            }}
                          >
                            <Typography
                              style={{
                                maxWidth: 400,
                                overflow: "hidden",
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                              }}
                              className="font600 fs_14"
                              dangerouslySetInnerHTML={{
                                __html: qObj?.answer,
                              }}
                            />
                          </Box>
                        </Box>
                      </TableCell>

                      <TableCell
                        align="left"
                        onClick={() => handleQNAModal(true, { ...qObj, index })}
                      >
                        <EditIcon />
                      </TableCell>
                      <TableCell
                        align="left"
                        onClick={() => handleQNAemove(index)}
                      >
                        <DeleteIcon />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </AccordionDetails>
      </Accordion>
      <AddQNAModal
        open={showQNAModal}
        handleClose={() => setShowQNAModal(false)}
        selectedQNA={selectedQNA}
        handleQNA={handleQNA}
      />
    </>
  );
};

export default FaqAccordian;
